<template>
  <div class="match-modal" v-if="show">
    <h1>Du hast ein neues Match!</h1>
    <h2 v-if="matchName">{{matchName}}</h2>
    <div class="buttons">
      <button @click="$emit('close')" class="no-background">Weiter Matchen</button>
      <router-link :to="'/chat?c=' + matchId" class="link-button">Zum Chat</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchModal',
  props: {
    show: Boolean,
    matchName: String,
    matchId: String
  },
  emits: ['close']
};
</script>

<style scoped>
.match-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.9);
  width: 85%;
  max-width: 400px;
  background: white;
  border-radius: var(--radius-xl);
  padding: 40px 32px;
  z-index: 1100;
  box-shadow: 0 0 0 100vw rgba(0,0,0,0.4), var(--shadow-strong);
  animation: modalIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
  text-align: center;
}

@keyframes modalIn {
  to { transform: translate(-50%, -50%) scale(1); opacity: 1; }
}

.match-modal h1 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 8px;
}

.match-modal .buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 32px;
}

.link-button {
  background: var(--primary-color);
  color: white;
  padding: 16px;
  border-radius: var(--radius-m);
  text-decoration: none;
  font-weight: 700;
  text-align: center;
}

.buttons button.no-background {
  background: #F5F5F7;
  color: var(--text-secondary);
  border: none;
  padding: 16px;
  border-radius: var(--radius-m);
  font-weight: 600;
  font-family: var(--font);
  font-size: 1rem;
  cursor: pointer;
}
</style>
